import { NumberCons, StringConst } from 'src/app/constants/const';
import { BaseResponseHttp } from '../http/commons.model';
import { CallPlace } from '../http/myActivity.model';
import { MissingItems, ProductMaxPieces, ProductMinPieces } from '../http/shoppingList';
import { TabsMissingProducts } from './general.model';
import { BooleanCons } from '../../constants/const';

export class MissingListProduct {
  itemCode: string;
  description: string;
  constructor() {
    this.itemCode = StringConst.empty;
    this.description = StringConst.empty;
  }
}

export interface MissingListProductsResponse extends BaseResponseHttp {
  response: MissingListProduct[];
}

export class MissingListRequest {
  offset: number;
  limit: number;
  activesPrinciples: string[];
  constructor() {
    this.offset = NumberCons.zero;
    this.limit = NumberCons.zero;
    this.activesPrinciples = [];
  }
}

export class NotAvailableItemsStructor {
  list: MissingItems[];
  callPlace: CallPlace;
  isInvalidFromProduct: boolean;
  invalidPackages: Array<string>;
  constructor() {
    this.list = [];
    this.callPlace = CallPlace.default;
    this.isInvalidFromProduct = false;
    this.invalidPackages = [];
  }
}

export interface IGetInvalidPackagesRes extends BaseResponseHttp {
  response?: InvalidPackagesData;
}
export class InvalidPackagesData {
  invalidItemCodes: InvalidPackageToDelete[];
  productsWithoutStock: ItemNoStock[];
  invalidItemCodesValidForSap: InvalidPackageToDelete[];
  invalidContainers: InvalidPackageToDelete[];
  productsMaxPieces: ProductMaxPieces[];
  productsMinPieces: ProductMinPieces[];
  hasProductPricesChanges: boolean;
  newTotalAmount: number;
  constructor() {
    this.invalidItemCodes = [];
    this.productsWithoutStock = [];
    this.invalidItemCodesValidForSap = [];
    this.invalidContainers = [];
    this.productsMaxPieces = [];
    this.productsMinPieces = [];
    this.hasProductPricesChanges = BooleanCons.false;
    this.newTotalAmount = NumberCons.zero;
  }
}

export class PricesHaveChanged {
  hasProductPricesChanges: boolean;
  newTotalAmount: number;
  constructor() {
    this.hasProductPricesChanges = BooleanCons.false;
    this.newTotalAmount = NumberCons.zero;
  }
}
export class ItemNoStock {
  itemCode: string;
  requestedQuantity: number;
  isPackage: boolean;
  piecesAvalibaleToSell: number;
  constructor() {
    this.itemCode = StringConst.empty;
    this.requestedQuantity = NumberCons.zero;
    this.isPackage = BooleanCons.false;
    this.piecesAvalibaleToSell = NumberCons.zero;
  }
}
export class InvalidPackageToDelete {
  itemCode: string;
  isSampleProduct: boolean;
  constructor() {
    this.itemCode = StringConst.empty;
    this.isSampleProduct = BooleanCons.false;
  }
}

export class DeleteItemsRequest {
  userId: string;
  itemCode: DeleteItem[];
  cartType: number;
  constructor() {
    this.userId = StringConst.empty;
    this.itemCode = [];
    this.cartType = NumberCons.zero;
  }
}

export class DeleteItem {
  itemCode: string;
  label: string;
  container: string;
  constructor() {
    this.itemCode = StringConst.empty;
    this.label = StringConst.empty;
    this.container = StringConst.empty;
  }
}

export class MissingProductBottomSheetConfig {
  activeOption: TabsMissingProducts;
  constructor() {
    this.activeOption = TabsMissingProducts.rawMaterial;
  }
}

export class MissingDynamicConfiguration {
  activeOption: string;
  options: string[];
  constructor() {
    this.activeOption = StringConst.empty;
    this.options = [];
  }
}

export const MissigProductEndType = {
  product: 'product',
  description: 'description',
};

export class DeleteOrder {
  transactionId: string;
  oldTransactionId: string;
  constructor() {
    this.transactionId = StringConst.empty;
    this.oldTransactionId = StringConst.empty;
  }
}
export class InvalidItemsChangePayment {
  itemCodes: string[];
  containers: string[];
  promotions: string[];
  constructor() {
    this.itemCodes = [];
    this.containers = [];
    this.promotions = [];
  }
}
